<template>
  <div id="se-tab-container" class="app-main-content">
    <cargo-up-down-resize
      class="app-main-inner section"
      :up-style="{ display: 'flex', flexDirection: 'column', paddingBottom: '5px' }"
      :down-style="{ display: 'flex', flexDirection: 'column', paddingTop: '5px' }"
      :show-down="containerConfig.showContainerCargoInfo"
      style="height: 100%"
    >
      <template slot="up">
        <div class="section operations">
          <div v-show="cooperateEdit" class="triggers">
            <div v-show="isEdit">
              <el-button no="1" type="primary" :disabled="selectedContainerUsage === null" @click="changeSealHandler">
                {{ $t('SeaExport.SealNoChangeAdfterInspection') }}
              </el-button>
              <el-button no="2" type="primary" :disabled="isAutoLoad" @click="autoLoadHandler">{{
                $t('SeaExport.AutoAllocation') }}</el-button>
              <el-button type="primary" @click="autoLoadContractHandler">{{ $t('SeaExport.AutoAllocationContract')
              }}</el-button>
              <el-button no="3" type="primary" :disabled="selectedContainerUsage === null" @click="autoUnloadHandler">
                {{ $t('SeaExport.CleanOutTheLoadingRecord') }}
              </el-button>
              <el-button
                v-if="!job.lclMasterUuid"
                no="4"
                type="danger"
                :disabled="selectedContainerUsage === null"
                @click="deleteContainerHandler"
              >{{ $t('SeaExport.DeleteTheLoadingRecord') }}
              </el-button>
              <!--      编辑NCM No.-->
              <el-button
                v-if="!job.lclMasterUuid"
                no="ncmNo"
                type="primary"
                :disabled="selectedContainerUsage === null"
                @click="editNcmNoHandler(true)"
              >{{ $t('CargoMsg.Cargo_Edit') + 'NCM No.' }}
              </el-button>
              <el-button
                v-if="!job.lclMasterUuid"
                no="4"
                type="primary"
                :disabled="selectedContainerUsage === null"
                @click="editNcmNoHandler(false)"
              >{{ $t('CargoMsg.Cargo_Edit') + $t('CargoMsg.Cargo_WoodenPackagingType') }}
              </el-button>
              <el-button v-if="isFCL" no="5" type="primary" @click="downTemplateBtn_clickHandler">
                {{ $t('SeaExport.TemplateDownload') }}
              </el-button>
              <el-upload
                action="string"
                :http-request="importExcelEventHandler"
                :show-file-list="false"
                accept=".xls, .xlsx"
                :before-upload="beforeUploadUsage"
                style="display: inline-block;padding-left: 5px;"
                no="6"
              >
                <el-button v-if="isFCL" v-show="isEdit" type="primary" no="7">{{ $t('SeaExport.ExcelImport') }}</el-button>
              </el-upload>
              <template v-if="containerConfig.showUpdatePortDataButton">
                <el-badge v-if="job.uuid" :is-dot="harbourCheckRead" class="item">
                  <el-button v-if="job.uuid" no="8" class="share-button" type="primary" @click="harbourCompare">{{
                    $t('SeaExport.UpdatePortAreaData') }}</el-button>
                </el-badge>
              </template>
              <el-button v-if="job.uuid" no="copyDoorPoint" type="primary" size="mini" @click="copyDoorPointData">{{
                $t('SeaExport.CopyDoorPoint') }}</el-button>
            </div>
            <!-- <div v-if="!isEdit && isHZ">
              <el-menu
                text-color="#404144"
                active-text-color="#404144"
                mode="horizontal"
                class="el-menu-button el-button el-button--primary el-button--mini"
                style="width: 90px;vertical-align: top"
                @select="toEDIContainers"
              >
                <el-submenu index="index">
                  <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.EDIContainers') }}</span>
                  <el-submenu index="original">
                    <template slot="title">{{ $t('SeaExport.Original') }}</template>
                    <el-menu-item index="API0">API</el-menu-item>
                  </el-submenu>
                </el-submenu>
              </el-menu>
            </div> -->
            <div>
              <span>
                {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
                {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}&nbsp;&nbsp;&nbsp;
                <el-button v-show="btnshowAWindow && !isEdit" type="primary" class="can-operate" no="9" @click="showAWindowClickHandler">{{
                  $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
              </span>
            </div>
            <!-- <div v-if="openXhqCustomsAll && !job.lclMasterUuid" style="float: right">
              <el-button type="primary" @click="xhqShowSendContainerHandler">{{ $t('CargoMsg.SendContainer') }}</el-button>
            </div>
            <div v-if="jingyuWarehouse && !job.lclMasterUuid">
              <el-button no="ReleaseJY" type="primary" style="margin-left: 200px;" @click="toReleaseJY">{{ $t('SeaExport.ReleaseJY') }}</el-button>
              <el-button no="TakeContainerJY" type="primary" @click="toTakeContainerJY">{{ $t('SeaExport.TakeContainerJY') }}</el-button>
              <el-button no="ContainerPreloadJY" type="primary" @click="toContainerPreloadJY">{{ $t('SeaExport.ContainerPreloadJY') }}</el-button>
            </div> -->
          </div>
        </div>
        <cargo-ag-grid
          config-module="130115"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="containerUsages"
          :wrap-text="true"
          style="width:100%;height:100%"
          @gridReady="params => gridApi = params.api"
        />
      </template>
      <template slot="down">
        <portData-goods-info
          ref="portDataGoodsInfo"
          :job="job"
          :is-editing="isEditGoods && isEdit"
          :is-or-not-display-so-no="true"
          :is-add-spelling="job.spelling"
          :del-po-items-uuids="delPoItemsUuids"
          :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
          :is-uppercase-by-config="isUppercaseByConfig"
          @change="handleChange"
        />
        <div v-if="jingyuWarehouse" style="width:80px">
          <span v-show="jingyuWarehouse && !isEdit" style="flex-direction: row-reverse;display: flex;justify-content: center;align-items: center;color:deepskyblue;" @click="showLclDynamicList"> {{ $t('SeaExport.LclDynamic') }} <i :class="jyLclDynamicDialog.visible?'el-icon-caret-bottom':'el-icon-caret-top'" /> </span>
        </div>
      </template>
    </cargo-up-down-resize>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainerUsage"
      @sealCloseHandler="sealCloseHandler"
    />
    <!-- 查看关联业务 -->
    <associated-business-dialog
      :visible.sync="associatedBusinessDialog.visible"
      :a-data="associatedBusinessDialog.aData"
      :job="job"
      @refresh="refresh"
    />
    <!-- 港区数据对比弹窗 -->
    <new-compare-harbour-dialog
      :visible.sync="harbourDialog"
      :data-source="poItems"
      :harbour-source="sourceList"
      :job="job"
      :hc-flag="hcFlag"
      :hq-flag="hqFlag"
      :container-height-flag="containerHeightFlag"
      :h-q-h-c-flag="HQHCFlag"
      @addContainer="handleAddContainer"
    />
    <!-- 抄录门点拖柜数据 -->
    <tab-container-record-link-dialog
      :visible.sync="containerRecordDialog.visible"
      :job-uuid="job.uuid"
      @selectTruckingRecordHandler="selectTruckingRecordHandler"
    />
    <!-- 箱子信息对比提示弹窗 -->
    <box-Information-Verification
      :dialog-visible.sync="dialogVisible"
      :content-show="contentShow"
      :container="container"
      :job-uuid="job.uuid"
    />
    <!-- 发送装箱信息到信号旗 -->
    <xhq-send-container-dialog
      v-if="openXhqCustomsAll"
      :dialog-visible.sync="xhqSendContainerDialog.visible"
      :job="job"
      :container-usage="xhqSendContainerDialog.containerUsage"
      :selected-container="xhqSendContainerDialog.container"
    />
    <!-- 编辑NCM 木制包装类型 -->
    <ncn-edit-dialog :job="job" :containers="ncnEditDialog.containers" :title="ncnEditDialog.title" :is-ncm-no="ncnEditDialog.isNcmNo" :visible.sync="ncnEditDialog.visible" @ncnEditChange="ncnEditChange" />
    <!-- 精谕放单弹窗 -->
    <jy-release-dialog :job="job" :containers="jyReleaseDialog.containers" :visible.sync="jyReleaseDialog.visible" />
    <!-- 精谕提箱弹窗 -->
    <jy-take-container-dialog :job="job" :containers="jyTakeContainerDialog.containers" :visible.sync="jyTakeContainerDialog.visible" />
    <!-- 精谕装箱弹窗 -->
    <jy-container-preload-dialog :job="job" :containers="jyContainerPreloadDialog.containers" :visible.sync="jyContainerPreloadDialog.visible" />
    <!-- 精谕拼箱动态弹窗 -->
    <jy-lcl-dynamic-dialog :job-uuid="job.uuid" :visible.sync="jyLclDynamicDialog.visible" />
    <!-- api选择弹框 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      :is-hz="isHZ"
      @selectedApi="selectedApiCallback"
    />
  </div>
</template>

<script>
import tabContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabContainer'

export default {
  name: 'SeTabContainer',
  extends: tabContainer,
  props: {
    containerConfig: { type: Object, default: () => { } }
  }
}
</script>

<style lang="scss">
#se-tab-container {
  .el-dialog__wrapper {
    pointer-events: none;
  }
  .el-dialog {
    pointer-events: auto;
  }
}
</style>

<style lang="scss" scoped>
.app-main-content {
  .operations {
    .triggers {
      overflow: visible;
      div {
        .el-badge {
          margin: 0 0 3px 5px;
        }
      }
    }
  }
}
.portData-service {
  padding-top: 10px;
  &>i {
    margin-right: 5px;
    color: #409EFF;
    font-size: 30px;
    vertical-align: middle;
  }
  &>span {
    line-height: 32px;
    vertical-align: middle;
    font-weight: bold;
    font-size: 16px;
    display: inline-block;
  }
  &>p {
    padding: 10px 0 10px 35px;
    line-height: 22px;
    font-size: 14px;
  }
}
</style>
